var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1001.971,
    height: 605.539,
    viewBox: "0 0 1001.971 605.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_engines-pana",
    "data-name": "Search engines-pana",
    transform: "translate(-205.086 -126.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-8",
    transform: "translate(347.792 126.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 156.813,
    height: 214.588,
    transform: "translate(0.622 33.82) rotate(-12.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M426.8,325.945l-.249-1.023c-.166-.691-.387-1.687-.664-2.959-.608-2.766-1.466-6.472-2.572-11.422-2.185-10.039-5.393-24.614-9.459-43.061-8.048-36.894-19.36-89.22-32.967-151.144l.774.5L228.414,150.021h0l.553-.857c16.871,78.351,32.5,150.895,45.163,209.776l-.691-.47L384.813,334.74l31-6.555,8.3-1.687,2.766-.553s-.885.249-2.766.664l-8.048,1.8-30.81,6.8L273.661,359.631h-.581v-.553c-12.75-58.881-28.459-131.4-45.44-209.72v-.719h.691L381.6,115.45h.636l.138.636c13.275,62.172,24.5,114.692,32.414,151.7,3.9,18.419,7,32.967,9.1,42.978,1.051,4.923,1.825,8.74,2.378,11.339l.581,2.9q0,.471-.055.94Z",
    transform: "translate(-227.64 -115.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M312.55,135.63c0,.415-16.594,4.314-37.088,8.767s-37.309,7.716-37.392,7.329,16.594-4.287,37.088-8.74S312.55,135.243,312.55,135.63Z",
    transform: "translate(-209.224 -79.874)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M354.275,139.073c0,.387-25.555,6.25-57.222,13.082s-57.471,12.086-57.553,11.7,25.555-6.25,57.249-13.082S354.275,138.686,354.275,139.073Z",
    transform: "translate(-206.699 -73.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M355.8,145.943c0,.387-25.527,6.25-57.222,13.109s-57.443,11.975-57.581,11.7,25.527-6.25,57.222-13.109S355.72,145.556,355.8,145.943Z",
    transform: "translate(-204.051 -61.645)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M357.275,152.823c0,.387-25.555,6.25-57.222,13.082S242.583,177.99,242.5,177.6s25.527-6.25,57.249-13.082S357.275,152.436,357.275,152.823Z",
    transform: "translate(-201.402 -49.498)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M358.72,159.693c0,.387-25.527,6.25-57.222,13.109S244,184.888,244,184.5s25.527-6.25,57.222-13.109S358.637,159.306,358.72,159.693Z",
    transform: "translate(-198.753 -37.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M360.275,166.573c0,.387-25.555,6.25-57.222,13.082s-57.471,12.086-57.554,11.7,25.527-6.25,57.249-13.109S360.109,166.186,360.275,166.573Z",
    transform: "translate(-196.105 -25.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M361.637,173.443c0,.387-25.527,6.25-57.222,13.109S247,198.638,247,198.251s25.527-6.25,57.222-13.109S361.554,173.056,361.637,173.443Z",
    transform: "translate(-193.456 -13.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M310.142,184.474c0,.387-13.662,3.706-30.7,7.384s-30.92,6.333-31,5.946,13.662-3.678,30.7-7.357S310.059,184.087,310.142,184.474Z",
    transform: "translate(-190.914 6.357)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plus--inject-8",
    transform: "translate(205.086 630.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M277.179,348.46a81.868,81.868,0,0,0-1.853-12.2,48.73,48.73,0,0,0-5.531-13.22A50.113,50.113,0,0,0,257.1,308.966a49.589,49.589,0,0,0-47.016-7.025,47.491,47.491,0,0,0-12.528,6.748A45.024,45.024,0,0,0,187.1,319.227a49.2,49.2,0,0,0,0,58.466A45.635,45.635,0,0,0,197.555,388.2a46.71,46.71,0,0,0,12.528,6.748,49.589,49.589,0,0,0,47.016-7.025,50.421,50.421,0,0,0,12.694-14.05,48.844,48.844,0,0,0,5.531-13.247,81.842,81.842,0,0,0,1.853-12.169s0,.277,0,.8v2.406a21.235,21.235,0,0,1-.332,3.872,33.425,33.425,0,0,1-.94,5.227,47.019,47.019,0,0,1-5.531,13.5A50.469,50.469,0,0,1,209.614,396.2a50.973,50.973,0,0,1-23.646-17.673,50.529,50.529,0,0,1,0-60.153,63.937,63.937,0,0,1,5.006-5.891,60.857,60.857,0,0,1,5.78-4.9,48.623,48.623,0,0,1,12.86-6.886,50.564,50.564,0,0,1,60.762,21.932,47.351,47.351,0,0,1,5.531,13.5,33.436,33.436,0,0,1,.94,5.227,21.7,21.7,0,0,1,.332,3.9v2.378A5.072,5.072,0,0,1,277.179,348.46Z",
    transform: "translate(-176.041 -297.694)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M194.974,357.33a224.19,224.19,0,0,1-.719-25.2,224.179,224.179,0,0,1,.719-25.2,212.6,212.6,0,0,1,.747,25.2A212.614,212.614,0,0,1,194.974,357.33Z",
    transform: "translate(-144.033 -281.369)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M235.723,316.57a223.474,223.474,0,0,1-25.168.719,223.733,223.733,0,0,1-25.2-.719,216.153,216.153,0,0,1,25.2-.719,215.881,215.881,0,0,1,25.168.719Z",
    transform: "translate(-159.586 -265.805)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--search-engine--inject-8",
    transform: "translate(360.007 463.895)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 845.326,
    height: 138.809,
    rx: 23.79,
    transform: "translate(0.728 1.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M470.25,237.45V377.5H588.482a70.054,70.054,0,0,0,70.055-70.027h0a70.027,70.027,0,0,0-70.054-70.027Z",
    transform: "translate(188.513 -237.45)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M548.227,280.545a64.207,64.207,0,0,0-1.189-7.135,29.538,29.538,0,0,0-10.786-15.958,28.929,28.929,0,0,0-27.435-4.038,27.1,27.1,0,0,0-7.329,4.01,28.866,28.866,0,0,0-6.112,40.268,26.828,26.828,0,0,0,6.112,6.14,27.186,27.186,0,0,0,7.3,3.955,29.261,29.261,0,0,0,38.221-19.941,63.971,63.971,0,0,0,1.189-7.163,23.152,23.152,0,0,1-.664,7.3,29.456,29.456,0,0,1-10.7,16.594,29.869,29.869,0,0,1-28.486,4.481,27.878,27.878,0,0,1-7.689-4.093,28.817,28.817,0,0,1-6.416-6.417,30.15,30.15,0,0,1,29.952-47.514,29.786,29.786,0,0,1,23.342,22.347A22.985,22.985,0,0,1,548.227,280.545Z",
    transform: "translate(220.471 -214.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M541.143,291.522a152.867,152.867,0,0,1-17.036-11.312,146.129,146.129,0,0,1-16.207-12.5,148.233,148.233,0,0,1,17.036,11.312,146.141,146.141,0,0,1,16.207,12.5Z",
    transform: "translate(254.99 -184.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 516.765,
    height: 29.703,
    transform: "translate(81.098 57.637)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M1012.315,377.362s1.632,0,4.785-.3a43.694,43.694,0,0,0,5.836-.747,60.15,60.15,0,0,0,7.938-1.8,66.6,66.6,0,0,0,20.245-10.178l2.766-2.047c.885-.774,1.742-1.6,2.627-2.406a56.87,56.87,0,0,0,5.255-5.365c1.8-1.881,3.208-4.176,4.923-6.361l2.157-3.568,1.106-1.853.94-1.964a63.6,63.6,0,0,0,5.808-17.479c.221-1.6.47-3.236.719-4.868a50.247,50.247,0,0,0,.276-5.034V302.938a65.408,65.408,0,0,0-63.361-63.832c-18.862-.166-38.885,0-59.849,0l-655.878.221a65.518,65.518,0,0,0-43.144,16.428,64.551,64.551,0,0,0-21.379,40.268,49.381,49.381,0,0,0-.47,5.753c0,1.908-.138,3.844,0,5.78a113.355,113.355,0,0,0,.442,11.533,63,63,0,0,0,6.555,21.793,65.546,65.546,0,0,0,32.165,30.422,66.377,66.377,0,0,0,21.572,5.172c3.678.249,7.412.221,11.063.221H445.8l294.875.166,198.768.221,54.069.138h0l-54.069.138-198.768.221-294.875.166H305.384c-3.734,0-7.44,0-11.229-.221a66.044,66.044,0,0,1-54.926-36.369,64.327,64.327,0,0,1-6.693-22.263,110.327,110.327,0,0,1-.47-11.7c0-1.936,0-3.872.138-5.836a46.555,46.555,0,0,1,.47-5.891A65.906,65.906,0,0,1,254.5,254.318a67.04,67.04,0,0,1,44.251-16.788l655.878.221c20.991,0,40.959,0,59.877.138a66.155,66.155,0,0,1,64.025,64.717v10.509c0,1.715-.194,3.4-.3,5.061s-.5,3.319-.747,4.923a63.6,63.6,0,0,1-5.918,17.617l-.94,1.991-1.134,1.825c-.747,1.245-1.466,2.434-2.213,3.623a79.2,79.2,0,0,1-4.978,6.361,51.413,51.413,0,0,1-5.282,5.393c-.913.83-1.8,1.659-2.766,2.406l-2.766,2.074a66.379,66.379,0,0,1-20.411,10.095,59.759,59.759,0,0,1-7.993,1.742,41.684,41.684,0,0,1-5.863.664A46.939,46.939,0,0,1,1012.315,377.362Z",
    transform: "translate(-232.057 -237.309)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8",
    transform: "translate(501.619 180.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M417.964,273.028c-2.517-2.932-2.766-5.531,2.9-5.919,12.473-1.134,21.655-6.582,23.121-9.735s-2.517-6.223-5.891-4.342a47.187,47.187,0,0,1-12.141,3.429,30.421,30.421,0,0,1-10.15,0c-2.9-.443-5.531-.94-7.744-1.41,0,0-13.192-2.766-18.89-7.3L361.24,277.592l13.109,14.8a19.83,19.83,0,0,0,17.479,8.3c11.229-1.106,26.357-9.154,26.357-9.154,2.047-3.153,20.134,8.02,25.97,12.2s10.122,3.125,9.9-.885c-.138-2.766-17.673-15.986-23.536-20a73.18,73.18,0,0,1-12.556-9.9",
    transform: "translate(-145.573 64.554)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M382.861,271.5c0,.194-.8.526-2.268.5a9.624,9.624,0,0,1-8.463-6.416c-.443-1.355-.3-2.268-.138-2.3a18.613,18.613,0,0,0,4.287,5.531,18.394,18.394,0,0,0,6.582,2.683Z",
    transform: "translate(-126.87 91.992)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M386.546,269.846c0,.166-.8.47-2.185.387a9.541,9.541,0,0,1-8.048-6.278c-.415-1.3-.332-2.157-.166-2.185a16.046,16.046,0,0,0,4.176,5.365,21.846,21.846,0,0,0,6.223,2.71Z",
    transform: "translate(-119.493 89.308)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M472.716,152.43c1.162,24.5,31.058,58.079,53.294,63.61,11.671,2.766,25.112,1.521,34.377,9.376,15.9,13.469,6.61,41.485,17.313,59.462,6.582,11.063,19.664,16.594,27.076,27.076,12.307,17.534,4.038,44.029-12.75,57.083s-39.189,15.543-60.236,14.99c-46.325-1.189-93.756-15.9-127.221-48.731-15.737-15.432-77.273-63.03-55.811-175.9",
    transform: "translate(-175.545 -103.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M747.588,254.127,571.5,201.856a112.065,112.065,0,0,0-25.638-7.716l-59.462.387a57.72,57.72,0,0,0-22.817,4.785l-160.27,53.239c-11.865,3.761-20.051,15.93-20.051,29.786h0c0,17.064,12.307,30.92,27.491,30.92h74.12l-.3,1.079,257.428.968h0l98.264.194c15.183,0,27.491-13.967,27.491-31.224C767.639,270.223,759.452,257.916,747.588,254.127Z",
    transform: "translate(-283.26 -30.104)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M537.921,226.661a7.8,7.8,0,0,1-1.6,0l-4.536-.526c-3.927-.5-9.625-1.134-16.594-1.8a511.108,511.108,0,0,0-55.313-2.323,517.686,517.686,0,0,0-55.147,3.761c-7.025.857-12.722,1.632-16.594,2.24l-4.536.636a8.291,8.291,0,0,1-1.576.138,5.365,5.365,0,0,1,1.521-.415l4.48-.913c3.9-.774,9.569-1.715,16.594-2.766a449.725,449.725,0,0,1,55.313-4.176,444.621,444.621,0,0,1,55.313,2.766c7.052.8,12.75,1.6,16.594,2.268l4.508.774A5.755,5.755,0,0,1,537.921,226.661Z",
    transform: "translate(-108.883 16.418)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(120.721 189.757)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M593.907,213.977a2.406,2.406,0,0,1-.5.581l-1.549,1.632c-1.383,1.41-3.429,3.512-6.223,6.057a101.95,101.95,0,0,1-10.7,8.6,52.546,52.546,0,0,1-16.456,7.855,42.26,42.26,0,0,1-21.987-.443,109.936,109.936,0,0,1-23.176-10.233,138.276,138.276,0,0,0-25.085-11.754,38.553,38.553,0,0,0-28.68,1.466c-9.265,4.176-17.147,10.537-25.748,15.128-2.13,1.189-4.4,2.1-6.582,3.1a69.33,69.33,0,0,1-6.776,2.24,64.771,64.771,0,0,1-13.552,2.351,69.888,69.888,0,0,1-45.053-12.39,123.081,123.081,0,0,1-13.607-12.086,65.959,65.959,0,0,0-10.537-8.6,28.4,28.4,0,0,0-10.786-4.038,16.343,16.343,0,0,1,3.015.332A26.051,26.051,0,0,1,338,206.98a65.877,65.877,0,0,1,10.786,8.518,124.834,124.834,0,0,0,13.635,11.837,69.142,69.142,0,0,0,44.389,11.892,64.3,64.3,0,0,0,13.275-2.323,66.369,66.369,0,0,0,6.61-2.24c2.129-.968,4.342-1.853,6.416-3.042,8.491-4.508,16.345-10.9,25.859-15.211a40.075,40.075,0,0,1,29.676-1.493,138.726,138.726,0,0,1,25.306,11.948A109.966,109.966,0,0,0,536.8,237.1a41.152,41.152,0,0,0,21.434.608,52.712,52.712,0,0,0,16.262-7.523,103.064,103.064,0,0,0,10.758-8.3c2.766-2.462,4.951-4.48,6.416-5.808l1.632-1.549C593.686,214.115,593.88,213.949,593.907,213.977Z",
    transform: "translate(-326.91 -203.44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(114.084 242.719)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M324.51,222.59l111.318,20.991-12.86,20.936-3.4.055Z",
    transform: "translate(-324.51 -222.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(319.656 220.732)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M530.209,214.64a7.9,7.9,0,0,1,0,1.687,38.226,38.226,0,0,1-.5,4.868,42.619,42.619,0,0,1-43.393,35.235,71.127,71.127,0,0,1-16.594-3.042c-5.531-1.576-10.924-3.319-16.207-4.37a46.242,46.242,0,0,0-15.377-.8,49.782,49.782,0,0,0-36.092,22.734l-1.438,2.406-.913,1.825a7.439,7.439,0,0,1-.857,1.493,11.048,11.048,0,0,1,.581-1.6c.249-.553.5-1.189.8-1.908l1.355-2.489a45.911,45.911,0,0,1,11.782-13.552A49.507,49.507,0,0,1,438,246.888a48.01,48.01,0,0,1,15.819.747c5.393,1.051,10.786,2.766,16.345,4.37a70.637,70.637,0,0,0,16.345,3.015A42.2,42.2,0,0,0,522.3,237.291a43.866,43.866,0,0,0,6.969-16.124C530.071,216.991,530.043,214.612,530.209,214.64Z",
    transform: "translate(-398.84 -214.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M290.56,270.439S491.79,359.161,490.9,357.2s31.943-60.236,31.943-60.236L359.812,216.37Z",
    transform: "translate(-270.371 9.147)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M324,220.53a29.515,29.515,0,0,1,4.149,1.742l11.063,5.227c9.348,4.453,22.125,10.7,36.313,17.7s26.91,13.386,36.12,18.087l10.869,5.531a27.043,27.043,0,0,1,3.9,2.24,24.884,24.884,0,0,1-4.148-1.715L411.2,264.117c-9.32-4.453-22.125-10.7-36.313-17.7s-26.91-13.386-36.12-18.087L327.9,222.8A29.288,29.288,0,0,1,324,220.53Z",
    transform: "translate(-211.327 16.492)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(17.894 262.224)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M428.594,231.378a17.339,17.339,0,0,1-1.88,5.974,28.154,28.154,0,0,1-12,12,37.254,37.254,0,0,1-11.063,3.983,44.7,44.7,0,0,1-13.607,0,102,102,0,0,1-29.344-9.846,155.016,155.016,0,0,0-28.735-11.118,50.587,50.587,0,0,0-13.165-1.521,41.039,41.039,0,0,0-11.395,1.936,30.92,30.92,0,0,0-14.05,8.795,58.11,58.11,0,0,0-3.623,4.978,18.367,18.367,0,0,1,3.208-5.338,30.423,30.423,0,0,1,14.16-9.4,41.322,41.322,0,0,1,11.643-2.157,50.557,50.557,0,0,1,13.524,1.438,148.458,148.458,0,0,1,28.846,11.229,104.212,104.212,0,0,0,28.929,9.846,43.171,43.171,0,0,0,13.22,0,36.9,36.9,0,0,0,10.9-3.706,28.375,28.375,0,0,0,11.975-11.339A46.11,46.11,0,0,0,428.594,231.378Z",
    transform: "translate(-289.73 -229.642)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(167.738 323.127)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M418.362,253.369c0,.249-4.453-.47-11.643-.608a101.066,101.066,0,0,0-12.584.664,104.867,104.867,0,0,0-15.128,2.987,106.519,106.519,0,0,0-14.437,5.365,102.769,102.769,0,0,0-11.062,6.057c-6.057,3.872-9.431,6.831-9.6,6.61a12.467,12.467,0,0,1,2.24-2.212,66.593,66.593,0,0,1,6.8-5.227,84.163,84.163,0,0,1,11.063-6.416,89.8,89.8,0,0,1,29.924-8.491,85.732,85.732,0,0,1,12.777-.332,62.243,62.243,0,0,1,8.546.885A11.756,11.756,0,0,1,418.362,253.369Z",
    transform: "translate(-343.91 -251.663)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(265.922 163.649)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M380.487,194c-3.319,9.293,1.659,19.36,6.527,27.933a75.75,75.75,0,0,0,11.671,16.954,25.5,25.5,0,0,0,18.281,8.3c9.044-.3,17.119-6.969,26.163-6.444,6.14.36,11.505,3.983,16.594,7.412a131.56,131.56,0,0,0,27.878,15.46,50.253,50.253,0,0,0,31.363,1.964,31.28,31.28,0,0,0,21.71-21.489",
    transform: "translate(-379.411 -194)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M423.152,289.75c.47-10.841,1.051-20.632,1.051-20.632s24.227-3.07,25.251-27.657-1.41-81.615-1.41-81.615L403.6,138.33,355.67,177.049l7.495,113.392a30.118,30.118,0,0,0,31.446,28.072h0a30.063,30.063,0,0,0,28.542-28.763Z",
    transform: "translate(-155.408 -128.645)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M391.48,164.2a3.07,3.07,0,1,1-3.125-3.1,3.125,3.125,0,0,1,3.125,3.1Z",
    transform: "translate(-103.021 -88.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M396.459,162.23c-.387.415-2.766-1.549-6-1.659s-5.78,1.549-6.14,1.106.221-.968,1.3-1.742a7.854,7.854,0,0,1,4.923-1.438,8.3,8.3,0,0,1,4.785,1.853C396.321,161.234,396.653,162.036,396.459,162.23Z",
    transform: "translate(-105.013 -93.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M378.235,164.2a3.1,3.1,0,1,1-3.153-3.1A3.1,3.1,0,0,1,378.235,164.2Z",
    transform: "translate(-126.504 -88.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M383.172,162.459c-.387.415-2.766-1.549-6.029-1.659s-5.78,1.549-6.112,1.106.221-.968,1.3-1.742a7.826,7.826,0,0,1,4.9-1.438,7.937,7.937,0,0,1,4.784,1.881C383.034,161.463,383.366,162.265,383.172,162.459Z",
    transform: "translate(-128.455 -92.649)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M380.46,189.361a21.6,21.6,0,0,1,5.531-.83c.83,0,1.659-.194,1.8-.8a4.866,4.866,0,0,0-.525-2.766c-.747-2.24-1.549-4.563-2.406-7.025a130,130,0,0,1-5.338-18.309,125.52,125.52,0,0,1,6.693,17.839c.8,2.461,1.576,4.812,2.3,7.052a5.531,5.531,0,0,1,.387,3.568,2.13,2.13,0,0,1-1.411,1.272,5.727,5.727,0,0,1-1.438.166,20.771,20.771,0,0,1-5.587-.166Z",
    transform: "translate(-113.297 -91.037)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M376.276,171.864c-3.374-2.213,9.376,5.531,16.124,5.393a9.071,9.071,0,0,1-10.924,3.4C374.34,177.7,376.276,171.864,376.276,171.864Z",
    transform: "translate(-120.01 -70.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M400.914,192.329a59.13,59.13,0,0,1-32.054-10.51s7.55,18,31.639,16.594Z",
    transform: "translate(-132.119 -51.857)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M346.732,207.487h0c0,21.379-5.67,77.936,33.188,85.736l-1.3-77.715s37.751-17.811,44.251-54.9l.221.221c2.406,5.531,6.721,17.617,4.093,27.408l35.373,8.712,4.065,3.706s12.584-27.657-11.7-52.548-45.053-6.887-58.079-8.3c-8.657-1.051-38.719-.857-50.916,50.861Z",
    transform: "translate(-172.606 -134.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M367.138,164.847c-3.291-2.047-7.8-.36-10.4,2.489a14.188,14.188,0,0,0,14.132,23.315",
    transform: "translate(-160.156 -83.421)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M363.091,178.552c0,.166-1.106.36-2.766,0a7.5,7.5,0,0,1-5.172-4.591,5.532,5.532,0,0,1,.166-4.038,5.892,5.892,0,0,1,2.1-2.461c1.549-1,2.766-.913,2.766-.747s-.968.525-2.13,1.576a4.785,4.785,0,0,0-1.493,5.2,7.3,7.3,0,0,0,4.148,4.093C362.068,178.137,363.091,178.331,363.091,178.552Z",
    transform: "translate(-156.856 -78.707)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M358.081,172.69a2.766,2.766,0,1,0,1.079,0",
    transform: "translate(-155.081 -67.977)",
    fill: "#1f5d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M421.775,263.938V223.31s-60.319,12.5-61.425,40.13Z",
    transform: "translate(-147.145 21.401)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M380.29,193.172A50.612,50.612,0,0,0,429.8,239.691c8.905.138,18.281-1.964,26.412,1.659,7.08,3.181,11.643,10.012,17.2,15.4a50.971,50.971,0,0,0,50.556,11.45c7.329-2.461,18.917-7.716,20.272-15.294,1.051-5.78-6.029-11.533-10.178-15.654a51.336,51.336,0,0,0-14.852-9.293c-42.978-20.189-89.082-34.847-136.486-37.364",
    transform: "translate(-111.937 -36.354)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgNotFound);
export default __webpack_public_path__ + "static/media/orgNotFound.f37a9e7b017978becb950c270b896f69.svg";
export { ForwardRef as ReactComponent };